import React from 'react';
import './HowToHelp.css';

const HowToHelp = () => {
  const helpOptions = [
    {
      icon: 'fas fa-heart',
      title: 'Donate',
      description: 'Your contribution directly funds student scholarships, educational materials, and mentorship programs. Every donation makes a measurable impact.',
      link: '#donate'
    },
    {
      icon: 'fas fa-hands-helping',
      title: 'Volunteer',
      description: 'Share your skills and time to mentor students, help with administrative tasks, or support our outreach programs.',
      link: '#volunteer'
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Sponsor a Student',
      description: 'Make a direct, long-term impact by sponsoring a student\'s entire educational journey from school through college.',
      link: '#sponsor'
    }
  ];

  return (
    <section className="help-section" id="help">
      <div className="container">
        <h2>Join Our Mission</h2>
        <div className="help-grid">
          {helpOptions.map((option, index) => (
            <div key={index} className="help-card">
              <i className={option.icon}></i>
              <h3>{option.title}</h3>
              <p>{option.description}</p>
              <a href={option.link} className="btn btn-primary">
                {option.title === 'Donate' ? 'Donate Now' : 
                 option.title === 'Volunteer' ? 'Volunteer Today' : 
                 'Sponsor a Student'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToHelp;